import { matchPath } from 'react-router-dom';
import { tourReportName } from '@/constants';
import { ordersReportName } from '@/constants';

export type DropdownOptions = Array<{ page: string; label: string }>;

interface INavigationSchema {
  path: string;
  label: string;
  group: string; // 'tourBag' | 'player'
  dropdownPlaceholder?: string;
  dropdownOptions?: DropdownOptions;
}

const navigationSchema: INavigationSchema[] = [
  {
    path: '/tourbag',
    label: 'Tour Bag',
    group: 'tour bag',
    dropdownPlaceholder: 'Reports',
    dropdownOptions: [
      // TODO: Add report modules
      { page: 'Tour/tourBagBsgReport', label: tourReportName.bsgReport },
      { page: 'Tour/tourBagReport', label: tourReportName.tourBagReport },
      { page: 'Tour/tourPlayerReport', label: tourReportName.tourPlayerReport },
      { page: 'Tour/marketingReport', label: tourReportName.marketingReport },
      { page: 'Tour/contractsReport', label: tourReportName.contractReport },
      { page: 'Tour/contractsHistoryReport', label: tourReportName.contractHistoryReport },
      { page: 'Tour/tourBagHistoryReport', label: tourReportName.transferClubReport },
    ],
  },
  {
    path: '/tourbag/:playerId',
    label: 'Player',
    group: 'player',
  },
  {
    path: '/orders',
    label: 'Orders',
    group: 'orders',
    dropdownPlaceholder: 'Reports',
    dropdownOptions: [
      { page: 'Order/clubOrderSystemReport', label: ordersReportName.clubOrderSystemReport },
      { page: 'Order/componentOrderSystemReport', label: ordersReportName.compOrderSystemReport },
      { page: 'Order/putterOrderSystemReport', label: ordersReportName.putterOrderSystemReport },
    ],
  },
  // add more routes here
];

export const getNavigationSchema = (pathname: string) => {
  const sortedSchema = [...navigationSchema].sort((a, b) => {
    return b.path.length - a.path.length; // longer paths first
  });
  for (const schema of sortedSchema) {
    const match = matchPath({ path: schema.path, end: false }, pathname);
    if (match) {
      return schema;
    }
  }
  return navigationSchema[0]; // default to tour bag landing page schema
};
